import { g as n } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSend",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["clip-path"], p = ["id"];
function _(a, t, l, h, g, i) {
  return d(), s("svg", {
    "aria-label": l.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--send"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Send",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      e("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.661 1.036a.5.5 0 0 1 .556-.083l9.546 4.597a.5.5 0 0 1 0 .9l-9.546 4.597a.5.5 0 0 1-.684-.63L3.233 6l-1.7-4.417a.5.5 0 0 1 .128-.547ZM4.111 6.5 2.92 9.599 9.355 6.5H4.11Zm5.244-1H4.11L2.92 2.401 9.355 5.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, m),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, [...t[1] || (t[1] = [
        e("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z",
          transform: "translate(.5)"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const q = /* @__PURE__ */ u(c, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=send.js.map
